import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/**
 * Fixed round Cyan button that appears after 400px of scroll.
 * Offset to right: 80px so it never overlaps the Chat widget at right: 24px.
 */
export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Back to top"
      className="fixed z-50 flex items-center justify-center rounded-full bg-[#23C0DD] text-white shadow-lg hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#23C0DD]"
      style={{
        width: 48,
        height: 48,
        bottom: 24,
        right: 80,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        pointerEvents: visible ? "auto" : "none",
        transition: "opacity 0.2s ease, transform 0.2s ease",
      }}
    >
      <ChevronUp size={20} aria-hidden="true" />
    </button>
  );
}